import {EsignerRole} from "../../../../../Common/Constant";
import {GetFormattedNumber} from "../../../../../Helpers/Formatters";
import {getESignerContactValues, getEsignPrefillData, isMissingPhoneOrEmail, setPhoneAndEmail} from "./eSignerFunctions";

const getTrusteeInfo = (formState, clientDataObj) => {
  const {trustees} = clientDataObj;

  if (!trustees || trustees.length < 1)
    return null;

  let trustArray = [];

  trustees.forEach(trustee => {
    let eSigner = {};
    eSigner.firstName = trustee.firstName;
    eSigner.lastName = trustee.lastName;
    eSigner.role = EsignerRole.TRUSTEE;

    const trusteeContact = getESignerContactValues(trustee);

    let emailList = [];
    let phoneList = [];

    // set dropdown values
    trusteeContact.emails.forEach((element, index) => {
      emailList.push({label: element, value: element})
    })
    trusteeContact.phones.forEach((element, index) => {
      phoneList.push({label: GetFormattedNumber(element), value: element})
    })

    eSigner.emailList = emailList;
    eSigner.phoneList = phoneList;

    const { phoneVal, emailVal } = setPhoneAndEmail(emailList, phoneList);
    const { prefillPhone, prefillEmail, prefillAuthentication } = getEsignPrefillData(EsignerRole.TRUSTEE, formState);
    eSigner.phone = prefillPhone || phoneVal;
    eSigner.email = prefillEmail || emailVal;
    eSigner.authentication = prefillAuthentication || ''

    eSigner.missingContact = isMissingPhoneOrEmail(emailList, phoneList);

    trustArray.push(eSigner);
  });

  return trustArray;
}

export default getTrusteeInfo;


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/ESign/Helpers/ESigner/getTrusteeInfo.js